import { HttpService } from "../http";

export class CourseService extends HttpService {
  fetchCategories = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/categories`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchFreeCategories = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/categories/public/${payload.slug}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
  fetchFaqs = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/faq`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addFaq = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/faq`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateFaq = async (id: number, payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/faq/${payload.id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteFaq = async (id: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/faq/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchCourses = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchFreeCourses = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/free/${payload.slug}`;
    try {
      const apiResponse = await this.get(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchCourse = async (id: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/${id}`;
    try {
      const apiResponse = await this.get(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchFreeCourse = async (id: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/detail-free/${id}`;
    try {
      const apiResponse = await this.get(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addCourse = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateCourse = async (id: number, payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/${id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteCourse = async (id: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  uploadThumbnail = async (formData: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/thumbnail`;
    const headers: TObject = {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    };
    try {
      const apiResponse = await this.post(baseUrl, formData, { headers });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Step 02
  addChapters = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // Step 03
  publishCourse = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  fetchCourseChapters = async (
    courseId: number,
    options?: { isSignedUrl?: boolean }
  ): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    let baseUrl = `${baseAuthUrl}/api/course-chapter/course/${courseId}`;
    if (options?.isSignedUrl) {
      baseUrl += "?isSignedUrl=true";
    }
    try {
      const apiResponse = await this.get(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addCourseChapter = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-chapter`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateCourseChapter = async (id: number, payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-chapter/${id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteCourseChapter = async (id: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  addCourseVideo = async (
    courseId: any,
    chapterId: any,
    formData: any
  ): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    console.log("formData entries:", Array.from(formData.entries()));
    const baseUrl = `${baseAuthUrl}/api/course-videos/v3/upload-chunked-direct/${courseId}/${chapterId}`;
    const headers: TObject = {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    };
    try {
      const apiResponse = await this.post(baseUrl, formData, { headers });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateCourseVideo = async (
    courseId: any,
    chapterId: any,
    formData: any
  ): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-videos/v3/upload-chunked-direct/${courseId}/${chapterId}`;
    const headers: TObject = {
      Accept: "application/json",
      "Content-Type": "application/x-www-form-urlencoded",
    };

    try {
      const apiResponse = await this.post(baseUrl, formData, { headers });
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  deleteCourseVideo = async (id: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-videos/${id}`;
    try {
      const apiResponse = await this.delete(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  postCourseEnrollData = async (
    courseId: number,
    payload: any
  ): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/${courseId}/takers`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  updateCourseEnrollData = async (
    courseId: number,
    id: number,
    payload: any
  ): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/courses/${courseId}/takers/${id}`;
    try {
      const apiResponse = await this.patch(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  postCourseProgressData = async (payload: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-taker-progress`;
    try {
      const apiResponse = await this.post(baseUrl, payload);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  // PATCH /api/course-taker-progress/{id}
  async patchCourseTakerProgress(id: number, payload: any): Promise<any> {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-taker-progress/${id}`;
    console.log(`📤 [PATCH API] Updating progress for ID ${id}:`, payload);
    const response = await this.patch(baseUrl, payload);
    console.log(`📥 [PATCH API] Response for ID ${id}:`, response);
    return response;
  }

  getCourseTakerProgressById = async (courseId: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-taker-progress/user/${courseId}`;
    console.log(`🌐 [GET API] Fetching from: ${baseUrl}`);
    try {
      const apiResponse = await this.get(baseUrl);
      console.log(`🌐 [GET API] Response data:`, apiResponse?.data);
      console.log(`🌐 [GET API] Progress items:`, apiResponse?.data?.data);
      return apiResponse;
    } catch (error) {
      console.error(`❌ [GET API] Error fetching progress:`, error);
      throw error;
    }
  };

  getCourseTakerProgress = async (params: any): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-taker-progress`;
    try {
      const apiResponse = await this.get(baseUrl, params);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };

  getVideoUrlById = async (id: number): Promise<any> => {
    const baseAuthUrl = process.env.REACT_APP_BASE_URL;
    const baseUrl = `${baseAuthUrl}/api/course-videos/url/${id}`;
    try {
      const apiResponse = await this.get(baseUrl);
      return apiResponse;
    } catch (error) {
      throw error;
    }
  };
}
